module.exports = __webpack_public_path__ + "static/assets/2eb44ece28fc0b4e5c28fc3abdcc8be6.png";